import { render, staticRenderFns } from "./NameForm.vue?vue&type=template&id=47f902d5&scoped=true&"
import script from "./NameForm.vue?vue&type=script&lang=js&"
export * from "./NameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f902d5",
  null
  
)

export default component.exports